import { randomRange } from '@components/Confetti/utils';
import { outQuad } from '@repo/utils/helpers/animation';

export default class Particle {
  ctx: CanvasRenderingContext2D;
  x: number;
  size: number;
  vx: number;
  angle: number;
  color: string;
  opacity: number;
  ctr: { x: number; y: number };
  halfWidth: number;

  constructor(ctx: CanvasRenderingContext2D, ctr: { x: number; y: number }) {
    this.ctx = ctx;
    this.halfWidth = ctx.canvas.width / 2;
    this.x = this.halfWidth / 3;
    this.size = randomRange(2, 5);
    this.vx = randomRange(0.05, 0.1);
    this.angle = randomRange(0, Math.PI * 2);
    this.color = '#fff';
    this.opacity = 1;
    this.ctr = ctr;
  }

  draw() {
    this.ctx.save();
    this.ctx.translate(this.ctr.x, this.ctr.y);
    this.ctx.rotate(this.angle);

    this.ctx.beginPath();
    this.ctx.fillStyle = this.color;
    this.ctx.globalAlpha = this.opacity;

    this.ctx.ellipse(this.x, 0, this.size / 2, this.size / 2, 2 * Math.PI, 0, 2 * Math.PI);
    this.ctx.fill();

    this.ctx.closePath();
    this.ctx.restore();
  }

  update() {
    this.x += this.vx;

    const startOfFade = this.halfWidth / 1.5;
    const endOfFade = this.halfWidth * 0.85;
    const diff = endOfFade - startOfFade;
    const progress = (this.x - startOfFade) / diff;
    this.opacity = this.x > startOfFade ? outQuad(1 - progress) : 1;

    this.draw();
  }

  isOffCanvas() {
    return this.opacity < 0.01 || this.x > this.halfWidth * 3;
  }
}

export class Ray {
  ctx: CanvasRenderingContext2D;
  x: number;
  vx: number;
  angle: number;
  opacity: number;
  rayGradient: CanvasGradient;
  ctr: { x: number; y: number };
  halfWidth: number;

  constructor(
    ctx: CanvasRenderingContext2D,
    ctr: { x: number; y: number },
    gradient: CanvasGradient,
  ) {
    this.ctx = ctx;
    this.halfWidth = ctx.canvas.width / 2;
    this.x = 1;
    this.vx = randomRange(0.3, 0.6);
    this.angle = randomRange(0, Math.PI * 2);
    this.opacity = 1;
    this.ctr = ctr;
    this.rayGradient = gradient;
  }

  draw() {
    this.ctx.save();
    this.ctx.translate(this.ctr.x, this.ctr.y);
    this.ctx.rotate(this.angle);

    this.ctx.beginPath();
    this.ctx.fillStyle = this.rayGradient;
    this.ctx.globalAlpha = this.opacity;

    this.ctx.moveTo(0, -1);
    this.ctx.lineTo(this.x, -1);
    this.ctx.lineTo(this.x, 1);
    this.ctx.lineTo(0, 1);

    this.ctx.fill();
    this.ctx.closePath();
    this.ctx.restore();
  }

  update() {
    this.x += this.vx;
    const startOfFade = this.halfWidth;
    const endOfFade = this.halfWidth * 1.6;
    const diff = endOfFade - startOfFade;
    const progress = (this.x - startOfFade) / diff;
    this.opacity = this.x > startOfFade ? outQuad(1 - progress) : 1;

    this.draw();
  }

  isOffCanvas() {
    return this.x > this.halfWidth * 1.5;
  }
}
